export default __webpack_public_path__ + "static/media/i115hp.fc115585.webp";